module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--2-6616641fdefd58eadfd1f5fb6c6b8a81.jpg";